import { render, staticRenderFns } from "./logoSignUp.vue?vue&type=template&id=dc4bf85c"
import script from "./logoSignUp.vue?vue&type=script&lang=ts"
export * from "./logoSignUp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc4bf85c')) {
      api.createRecord('dc4bf85c', component.options)
    } else {
      api.reload('dc4bf85c', component.options)
    }
    module.hot.accept("./logoSignUp.vue?vue&type=template&id=dc4bf85c", function () {
      api.rerender('dc4bf85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/logo/logoSignUp.vue"
export default component.exports